import { APIClient } from "../api";
import axios, { AxiosAdapter } from 'axios';
export default class HeyHoUserService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async getUsersAttendant(IdUser: number, idGroup: number) {

        const url = this.endpoint + `/User/GetAttendants/${IdUser}/${idGroup}`;

        return (await this.api({
            method: 'get',
            url
        })).data;

    }
    async GetRequesters(userId: number, CustomerId: any) {
        const url = this.endpoint + `/User/GetRequesters/${userId}/${CustomerId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetRequestersV2(userId: number) {
        const url = this.endpoint + `/User/GetRequestersV2/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetUsersAttendantMulti(userId: any, WorkTeamId: string, customerIdList?: string) {
        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        //Save the cancel token for the current request
        this.cancelToken = axios.CancelToken.source();
        const url = this.endpoint + `/User/GetAttendantsMulti/${userId}/${WorkTeamId}/?customerId=${customerIdList}`;

        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }

    async getAttendantsByProcess(processId: number) {
        const url = this.endpoint + `/User/GetAttendantsByProcess/${processId}`;

        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        //Save the cancel token for the current request
        this.cancelToken = axios.CancelToken.source();
        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }

    async SaveHelperStatus(userId: number, type: string) {
        const url = this.endpoint + `/User/SaveHelperStatus/${userId}/${type}`;

        return this.api({
            method: 'POST',
            url
        });
    }

    async GetHelperStatusByUserId(userId: number) {
        const url = this.endpoint + `/User/GetHelperStatusByUserId/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetUserByNickName (nickname: string, customerId: number) {
        const url = `${this.endpoint}/User/GetUsersByNickName/${nickname}?CustomerId=${customerId}`;;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetWorkTeamManagerListByWorkTeamId(teamId: number) {
        const url = `${this.endpoint}/User/GetWorkTeamManagerListByWorkTeamId/${teamId}`;

        return await this.api({
            method: 'get',
            url,
            headers: { "Content-Type": "application/json" },
        });
    }

    async GetWorkTeamManagerByWorkTeamList(workTeamList: any[]) {
        const url = `${this.endpoint}/User/GetWorkTeamManagerByWorkTeamList`;

        return await this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            data: workTeamList,
        });
    }
}